import(/* webpackMode: "eager", webpackExports: ["PinnedEvent"] */ "/home/runner/work/brics-website/brics-website/entities/pinned-event/pinned-event.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecondEvent"] */ "/home/runner/work/brics-website/brics-website/entities/second-event/second-event.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsFeed"] */ "/home/runner/work/brics-website/brics-website/sections/events-feed/events-feed.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/sections/pinned-events/pinned-events.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/app/[locale]/events/page.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
